import { createDataMapper } from '@common/utils/query/dataMappers';
import { BackendAccount, Account } from '../types';

const resolveAccountName = (account: BackendAccount): string => {
    return (
        account.humanName ||
        account.accountHumanName ||
        account.accountName ||
        account.ownerUsername ||
        `Account #${account.id}`
    );
};

const mapBackendAccountToFrontendAccount = (
    backendAccount: BackendAccount,
): Account => {
    return {
        id: backendAccount.id,
        name: resolveAccountName(backendAccount),
        status: backendAccount.subscriptionStatus,
        rights: backendAccount.rights,
        isPersonal: backendAccount.ownerId === backendAccount.userId,
        ownerUsername: backendAccount.ownerUsername,
    };
};

export const transformAccount = createDataMapper<BackendAccount, Account>(
    mapBackendAccountToFrontendAccount,
    true,
);
